import PropTypes from 'prop-types'

export const linkPropTypes = {
  label: PropTypes.string,
  href: PropTypes.string
}

export const linksPropTypes = {
  links: PropTypes.arrayOf(PropTypes.shape(linkPropTypes))
}

export const testimonialPropTypes = PropTypes.shape({
  text: PropTypes.string,
  person: PropTypes.shape({
    name: PropTypes.string,
    company: PropTypes.string,
    img: PropTypes.string
  })
})

export const testimonialsCarouselPropTypes = {
  testimonials: PropTypes.arrayOf(testimonialPropTypes),
  className: PropTypes.string
}

export const processPointPropTypes = {
  id: PropTypes.string,
  title: PropTypes.string,
  desc: PropTypes.string
}

export const processPointsPropTypes = PropTypes.arrayOf(
  PropTypes.shape(processPointPropTypes)
)
